import React, { useEffect, useRef } from 'react'

const TemplateRenderer = (props) => {
  const combinedContent = `
    <style>${props.css}</style>
    ${props.html}
  `

  return (
    <iframe
      srcDoc={combinedContent}
      title="Document Preview"
      className=""
      style={{ width: '100%', height: '100%', border: '5px solid lightgrey' }}
      sandbox="allow-scripts"
    />
  )
}

export default TemplateRenderer
